import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { formatNumber } from 'ddc-intl';
import { trackEvent } from 'ddc-track-event';
import { getFilterParams } from '../utils/submitSearchUtils';

const ResultItem = ({
	result,
	input,
	submitSearch,
	appliedFilters,
	contextEnabled,
	active,
	onMouseOver = () => {},
	onMouseOut = () => {}
}) => {
	const { locale, widgetName, windowId } = useSelector(
		state => state.requestData
	);
	const optionalAttributes = {};
	const {
		labels,
		prefs: { showCounts }
	} = useSelector(state => state); // TODO: use common data hook
	const { id, facetInfo, suggestion, count } = result;
	let Result = (
		<li key="sorry">
			<span className="error list-group-item">
				{labels.NO_RESULTS_MATCHING_X.replace('{search}', `"${input}"`)}
			</span>
		</li>
	);

	if (onMouseOver) {
		optionalAttributes.onMouseOver = onMouseOver;
		optionalAttributes.onFocus = onMouseOver;
	}
	if (onMouseOut) {
		optionalAttributes.onMouseOut = onMouseOut;
		optionalAttributes.onBlur = onMouseOut;
	}

	if (facetInfo) {
		const filters = contextEnabled ? appliedFilters : [];
		const facet = Object.keys(facetInfo).join();
		const value = Object.values(facetInfo).join();
		const search = new RegExp(input, 'gi');
		// const matches = Array.from(suggestion.matchAll(search)); TODO replace code below with this after node v >=12
		// const matches = [];
		const matches = Array.from(suggestion.matchAll(search));

		Result = (
			<li key={id}>
				<a
					className={`list-group-item ${active ? 'selected' : ''}`}
					href={`?${getFilterParams([
						...filters,
						{ id: facet, values: [{ value }] }
					])}`}
					onClick={e => {
						submitSearch(e, result);
						trackEvent(widgetName, windowId, {
							element: 'all inventory autocomplete result',
							elementCTA: facet,
							result: 'form submitted'
						});
					}}
					{...optionalAttributes}
				>
					<span
						className="font-weight-bold"
						aria-label={suggestion}
						aria-selected={active}
					>
						{suggestion.split(search).reduce((prev, curr) => (
							<React.Fragment>
								{prev}
								<span className="font-weight-normal">
									{matches.shift()}
								</span>
								{curr}
							</React.Fragment>
						))}
					</span>
					{showCounts === 'true' && (
						<small className="text-muted">
							{formatNumber(count, locale)}
						</small>
					)}
				</a>
			</li>
		);
	}

	return Result;
};

ResultItem.propTypes = {
	result: PropTypes.shape({
		id: PropTypes.number,
		facetInfo: PropTypes.shape({}),
		suggestion: PropTypes.string,
		count: PropTypes.number
	}).isRequired,
	input: PropTypes.string.isRequired,
	submitSearch: PropTypes.func.isRequired,
	appliedFilters: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
	contextEnabled: PropTypes.bool.isRequired,
	onMouseOver: PropTypes.func,
	onMouseOut: PropTypes.func
};

export default ResultItem;
